namespace TabAurous.Reports {
    export namespace StockBifurcationService {
        export const baseUrl = 'Reports/StockBifurcation';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<StockBifurcationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ProductFilterList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<StockBifurcationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetVouchers(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockBifurcationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Reports/StockBifurcation/List",
            ProductFilterList = "Reports/StockBifurcation/ProductFilterList",
            GetVouchers = "Reports/StockBifurcation/GetVouchers"
        }

        [
            'List', 
            'ProductFilterList', 
            'GetVouchers'
        ].forEach(x => {
            (<any>StockBifurcationService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
